import {
  SAVE_GOOGLE_CONTACT_REQUEST,
  SAVE_GOOGLE_CONTACT_SUCCESS,
  SAVE_GOOGLE_CONTACT_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: {},
  loading: false,
  error: null,
};
export const saveAndSendInvitationReducer = (
  state = initialState,
  action: any
) => {
  switch (action.type) {
    case SAVE_GOOGLE_CONTACT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_GOOGLE_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SAVE_GOOGLE_CONTACT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case "SAVE_GOOGLE_CONTACT_EMPTY":
      return {
        ...state,
        loading: false,
        error: null,
        data: null,
      };
    default:
      return state;
  }
};
